<div class="mb-3 d-flex flex-row justify-content-between align-items-center flex-wrap">
    <button type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="backToRegistre()">
        <div class="d-flex align-items-center">
            <mat-icon>keyboard_arrow_left</mat-icon>
            Tipuri Registre
        </div>
    </button>
</div>
<div class="row">
    <div class="col-md">
        <p class="label-text">Tip Registru</p>
        <mat-form-field>
            <mat-select [(ngModel)]="selectedRegistruId" (selectionChange)="onRegistruChange($event.value)">
                <mat-option *ngFor="let registru of registre$ | async" [value]="registru.id">
                    {{ registru.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-md">
        <p class="label-text">An emitere document</p>
        <mat-form-field>
            <mat-select [(ngModel)]="selectedValabilitate" (selectionChange)="onValabilitateChange($event.value)">
                <mat-option *ngFor="let valabilitate of valabilitatiRegistru$ | async" [value]="valabilitate.id">
                    {{ valabilitate.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="table-container"
    [ngClass]="{ 'hide-table': selectedRegistruId === -1 || selectedValabilitate === -1 || isLoading}">
    <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"></table>
</div>
<div class="text-center" *ngIf="(selectedRegistruId === -1 || selectedValabilitate === -1) && !isLoading">
    <span class="noType-text">Selectați un tip de registru și anul de emitere al documentelor</span>
</div>
<div class="section-spinner" *ngIf="isLoading">
    <div class="spinner d-flex flex-column justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>